import React, { useEffect, useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// React Bootstrap
import { Alert, Button, Col, Form } from "react-bootstrap";
// Search Select
import SearchSelectObserver from "../../generic/MySearchSelectObserver";
// jquery
import $ from "jquery";
// Utils
import { addYears, dateToString2 } from "../../../utils";
// Components
import HorizontalCard from "../../generic/HorizontalCard";
import TooltipIcon from "../../generic/TooltipIcon";
// Styled
import styled from "styled-components";
import { produceWithPatches } from "immer";
// Contexto
import { dateToStringEN } from "../../../utils";

const CardUsuario = styled(HorizontalCard)`
  width: 100%;
`;

const FormDestino = ({ idEntidad, idSubEntidad, type, defaultValues, submissionHandler, handlerEndDate, noControl }) => {
  // Comprueba si estamos editando
  const estamosEditando = !!defaultValues?.id;

  // Validación del formulario
  const [validated] = useState(false);
  // Métodos para use hook forms
  const methods = useForm({
    defaultValues: defaultValues,

  });
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = methods;



  // Usuarios para el search select
  const [usuarios, setUsuarios] = useState([]);

  const [todasHermanasProvincia, setTodasHermanasProvincia] = useState(false);
  const [todasHermanas, setTodasHermanas] = useState(false);

  // Default value para el search select
  const [defaultUsuario, setDefaultUsuario] = useState({});

  //mensaje seleccionado en el select al insertar 
  const [mensajeDestinoHermana, setMensajeDestinoHermana] = useState([])

  //mensaje de advertencia
  const [mensajeAdvertencia, setMensajeAdvertencia] = useState(false)

  // Controla el usuario por defecto y lo guarda 
  useEffect(() => {
    if (estamosEditando) setDefaultUsuario({ name: `${defaultValues.name} ${defaultValues.firstSurname} ${defaultValues.secondSurname}`, value: defaultValues.id, startDate: '1990-01-01' });
  }, []);

  //esta pendiente con watch del cambio del usuario seleccionado y cargarlo en el hook correspondiente para poder analizar los detinos de la hermana seleccioanda y mostrar info en pantalla sobre su destiono actual y posteriormente para darlo de baja y crear el nuevo destino, osea, pincho en select, escojo y me muestra info.
  useEffect(() => {
    //setUsuarioSeleccionado(watch().userId)
    obtenDestinoActualHermana(watch().userId)

  }, [watch().userId]);

  // On submit del formulario
  const onSubmit = (data) => {
    submissionHandler(data, noControl);
  };

  // Para el search select
  const getUsuarios = (page, findName, consulta, usuarioId) => {
    let settings = {
      // TODO
      url: getUrl(page, findName, consulta, usuarioId),
      method: "GET",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Manejador de la respuesta de getUsuarios
  const handleGetUsuarios = (page = 1, findName = "", addMore = false) => {
    return getUsuarios(page, findName)
      .then((response) => {
        addMore ? setUsuarios([...usuarios, ...processUsuarios(response.items)]) : setUsuarios(processUsuarios(response.items));
        return response;
      })
      .catch(() => {
      });
  };

  // Procesamiento de la función que obtiene los usuarios
  const processUsuarios = (usuarios) => {
    return usuarios.map((miUsuario) => {
      let nuevoUsuario = {};

      nuevoUsuario.component = (
        <CardUsuario
          title={<small>{`${miUsuario.name} ${miUsuario.firstSurname} ${miUsuario.secondSurname}`}</small>}
          heightPhoto={"4rem"}
          cardImage={miUsuario.photo ? `${process.env.REACT_APP_API_URL}/download/usuarios/${miUsuario.id}` : "/images/nun.png"}
          imgOnError={"/images/nun.png"}
          destino={miUsuario.sister?.destinations[0] ?
            `Último destino ${miUsuario.sister?.destinations[0]?.endDate ?
              `${new Date(miUsuario.sister?.destinations[0]?.endDate) < new Date() ? `finalizado` : `finaliza`} el ${miUsuario.sister?.destinations[0]?.endDate}`
              :
              `aún en vigor`
            }: ${miUsuario.sister?.destinations[0]?.province?.name}, ${miUsuario.sister?.destinations[0]?.community?.name}`
            :
            null}
        />
      );

      nuevoUsuario.name = `${miUsuario.name} ${miUsuario.firstSurname} ${miUsuario.secondSurname}`;
      nuevoUsuario.value = miUsuario.id;
      return nuevoUsuario;
    });
  };

  // Obtiene la url para pedir usuarios
  const getUrl = (page, findName, consulta, usuarioId) => {
    switch (type) {
      // Destinos      
      case "hermanasComunidad":
        if (usuarioId) return `${process.env.REACT_APP_API_URL}/usuarios/${usuarioId}`
        if (!noControl) return todasHermanas ?
          `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&findName=${findName}&allUser=true`
          :
          `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&provincia=${idEntidad}&findName=${findName}${todasHermanasProvincia ? '&todasProvincia=1' : ''}`;
        if (noControl) return `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&page=${page}&findName=${findName}&allUser=true`;
        break
      default:
        return "";
    }
  };

  // Obtiene el mensaje para el tooltip del buscador
  const getToolTipMessage = (editando) => {
    switch (type) {
      // Destinos      
      case "hermanasComunidad":
        if (!editando) return `Busque y seleccione entre todas las hermanas de la provincia`;
        if (editando) return `Modifique las fechas de este destino`;
        break
      default:
        return "";
    }
  };

  // Validación para la fecha de fin puede que sea required o no
  const isEndDateRequired = () => {
    switch (type) {
      // Provincial y general
      case "hermanasComunidad":
        return false;
      default:
        return true;
    }
  };

  //prueba
  const obtenDestinoActualHermana = async (usuarioSeleccionado) => {

    if (usuarioSeleccionado) {
      return await getUsuarios(1, '', '', usuarioSeleccionado)
        .then((response) => {

          const fechaFin = response.sister.destinations[0].endDate ? response.sister.destinations[0].endDate : 'sin definir'
          setMensajeDestinoHermana([
            response.sister.destinations[0].community.name,
            response.sister.destinations[0].province.name,
            response.sister.destinations[0].startDate,
            fechaFin
          ])

        })
        .catch((e) => {
          setMensajeDestinoHermana([])
        })
    }
  }
  //manejador fecha de fin
  const manejadorFechaFin = (e) => {
    setValue("endDate", dateToString2(new Date(e.target.value)))
    setMensajeAdvertencia(dateToStringEN(Date.now()) >= dateToStringEN(e.target.value));
  }

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      {noControl && (
        <Alert variant="danger" title="cuidado">
          <Alert.Heading>
            <b>¡Cuidado!</b>
          </Alert.Heading>
          Está accediendo a una parte del sistema donde no hay restricciones en la inserción de datos. Las acciones que se lleven a cabo estarán bajo su responsabilidad.
        </Alert>
      )}
      {mensajeAdvertencia && (
        <Alert variant="danger" title="cuidado">
          <Alert.Heading>
            <b>Atención!</b>
          </Alert.Heading>
          Si establece una "FECHA DE FIN" inferior o igual a la fecha actual, el destino se dará por finalizado y desaparecerá de esta tabla. Podrá consultar este destino en el apartado Adscripción/Destino de la hermana o en el informe correspondiente
        </Alert>
      )}

      <Form.Row>
        <small className="mb-3" >
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>
      {mensajeDestinoHermana[0] && <Form.Row className="rounded-lg bg-body p-2 mb-3 border border-info" style={{ backgroundColor: '#d1ecf1' }} >
        <>
          <p >
            El <strong>DESTINO ACTUAL</strong> de la hermana seleccionada es:
            <br></br>
            <u>Comunidad:</u> <strong>{mensajeDestinoHermana[0]}</strong>
            <br></br>
            <u>Provincia:</u> <strong>{mensajeDestinoHermana[1]}</strong>
            <br></br>
            <u>Desde:</u> <strong>{mensajeDestinoHermana[2]}</strong>, <u>Hasta:</u> <strong>{mensajeDestinoHermana[3]}</strong>
            <br></br>
            <br></br>
            Nota: Al guardar el destino la hermana causará baja en la comunidad actual en la fecha de inicio del nuevo destino.
            <br></br> <br></br>
            RECUERDE!!: Temporalmente y por orden de la Dirección General para facilitar la puesta al día de la base de datos, la aplicación no contrala las fechas en los destinos por lo que le rogamos preste especial atención a la cronología de los destinos
          </p>
        </>
      </Form.Row>}

      <Form.Row>

        <Form.Check
          className="mr-4"
          type="checkbox"
          label={`Mostrar todas las hermanas que hayan pertenecido a la Provincia`}
          defaultChecked={false}
          checked={todasHermanasProvincia}
          onClick={(e) => setTodasHermanasProvincia(e.target.checked)}
        />
        <Form.Check

          type="checkbox"
          label={`Mostrar todas las hermanas de la Congregación`}
          defaultChecked={false}
          checked={todasHermanas}
          onClick={(e) => setTodasHermanas(e.target.checked)}
        />
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} xs={12} md controlId="usuario-añadir-destino">
          <Form.Label className="d-flex mt-3">
            Hermana *
            <TooltipIcon className="pl-2" content={getToolTipMessage(estamosEditando)} />
          </Form.Label>
          {!estamosEditando && <SearchSelectObserver
            options={usuarios}
            name={"userId"}
            reactHookFormsRef={
              register("userId", { required: "Este campo es obligatorio", })
            }
            requestMoreOptions={handleGetUsuarios}
            methods={methods}
            defaultValue={defaultUsuario}
            ErrorMessage={ErrorMessage}
          />}
          {estamosEditando && <Form.Row className="rounded-lg bg-body p-2 mb-3 border border-info" style={{ backgroundColor: '#d1ecf1' }} >
            <>
              <p >
                Está <strong>EDITANDO EL DESTINO</strong> de la hermana:
                <br></br><br></br>
                <strong>{defaultUsuario.name}</strong>
                <br></br>
                <br></br>
                Nota: Recuerde que no puede modificar un destino con fecha de inicio mayor o menor a 90 días de la fecha actual
                <br></br>
                <br></br>
                RECUERDE!! Temporalmente y por orden de la Dirección General para facilitar la puesta al día de la base de datos, la aplicación no contrala las fechas en los destinos por lo que le rogamos preste especial atención a la cronología de los destinos
              </p>
            </>
          </Form.Row>}
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group as={Col} xs={12} md controlId="activity-start-mission">
          <Form.Label>{"Fecha de inicio"} *</Form.Label>
          <Form.Control
            name="startDate"
            type="date"
            defaultValue={defaultValues?.sister?.destinations?.[0]?.startDate}
            // disabled={!estamosEditando}
            isInvalid={errors?.startDate}
            {...register("startDate", {
              required: "Este campo es obligatorio",
              validate: {
                //dateMayorQueHoy: (date) => {
                //   let today = new Date();
                //   if (!noControl) return new Date(today.getFullYear(), today.getMonth(), today.getDate()) <= new Date(date) ? true : "La fecha debe ser mayor o igual a hoy";
                // },
                dateMenorQueEndDate: (date) => {
                  if (watch("endDate")) return new Date(watch("endDate")) > new Date(date) ? true : "La fecha de inicio debe ser menor o a la fecha de fin";
                },
              },
            })}
            // Para controlar que al añadir cada vez que se cambia el valor del startdate se cambie el valor del endDate
            onChange={(e) => {
              // Si no estamos editando y estamos en servicios de provincia o direccion general
              if (!estamosEditando && handlerEndDate()) setValue("endDate", dateToString2(addYears(new Date(e.target.value), handlerEndDate())));
            }}
          />
          <ErrorMessage errors={errors} name="startDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>

        <Form.Group as={Col} xs={12} md controlId="activity-end-mission">
          <Form.Label className="d-flex">
            {"Fecha de fin"} {isEndDateRequired() && "*"}
            {!estamosEditando && handlerEndDate() && <TooltipIcon className="pl-2" content={"Puede establecer la fecha de fin de destino o dejarla en blanco"} />}
          </Form.Label>
          <Form.Control
            name="endDate"
            type="date"
            defaultValue={defaultValues?.sister?.destinations?.[0]?.endDate}
            //value={defaultValues?.sister?.destinations?.[0]?.endDate}
            isInvalid={errors?.endDate}
            {...register("endDate", {
              validate: {
                correctDate: (date) => {
                  if (!noControl && date && !estamosEditando) return new Date(date) <= new Date(watch("startDate")) ? "La fecha no debe ser mayor a la fecha de inicio" : true;
                  if (!noControl && date && estamosEditando) return new Date(date) <= new Date(watch("startDate")) ? "La fecha no debe ser mayor a la fecha de inicio" : true;
                },
                isEndDateRequired: (date) => {
                  if (isEndDateRequired() && !date) return "Este campo es obligatorio";
                },
              },
            })}
            onChange={manejadorFechaFin}
          />
          <ErrorMessage errors={errors} name="endDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
      </Form.Row>

      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormDestino;
